module.exports = {
  VALIDATION: {
    cpf: 'Número de documento inválido',
    birthdate: 'Data de nascimento inválida',
  },
};
